// Shared across every TinyMCE `<editor>` instance in the app so the button group only has to change in one place.
export const ALIGN_TOOLBAR_GROUP = 'alignleft aligncenter alignright alignjustify';
